<div class="selectable-card" (click)="onClick()">
    <div class="content">
        <div class="title ellipsis-text">{{ message }}</div>
        <div class="subtitle ellipsis-text">
            {{ subtitle }}
        </div>
    </div>
</div>
